import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PageDTO} from '../../../common/dtos/PageDTO';
import {UserApplication} from '../components/user-application-dialog/user-application';

@Injectable()
export class UserApplicationService {

  constructor(private _http: HttpClient) {
  }

  getList(params: PageDTO) {
    return this._http.post<any>(`api/a/userApplication/getList`, params);
  }

  get(id: number) {
    return this._http.get<UserApplication>(`api/a/userApplication/get/` + id);
  }

  getStateList() {
    return this._http.get<any>(`api/a/userApplication/getStateList`);
  }

  save(formData) {
    return this._http.post<any>(`api/s/userApplication/save`, formData, {headers: {'noContentType': 'true'}});
  }

  accept(application: UserApplication) {
    return this._http.post<any>(`api/a/userApplication/accept`, application);
  }

  reject(id: number, rejectReason: string) {
    return this._http.post<any>(`api/a/userApplication/reject/` + id, rejectReason);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/services/user-application.service.ts